export enum featureFlags {
  Stores = "Stores",
  ZoneBanners = "ZoneBanners",
  CopyStoreDSD = "CopyStoreDSD",
  Suppliers = "Suppliers",
  ReceivingRestrictions = "ReceivingRestrictions",
  /**
   * @deprecated Use ReceivingRestrictions instead.
   * Kept as an alias for backward compatibility with existing flag config.
   */
  ItemAuthorizations = ReceivingRestrictions,
  ItemStateFlag = "ItemStateFlag",
  PseudoUpc = "PseudoUpc",
  PriceGroupMove = "PriceGroupMove",
  MaintainStoreCoupons = "MaintainStoreCoupons",
  MiscellaneousTransactionCodes = "MiscellaneousTransactionCodes",
  UserClaims = "UserClaims",
  Admin = "Admin",
  ShipperCost = "ShipperCost",
  DealCost = "DealCost",
  CopyStoreZones = "CopyStoreZones",
  DSDCostLink = "DSDCostLink",
  DisplayCostDetails = "DisplayCostDetails",
  ItemMaintenance = "ItemMaintenance",
  Promotions = "Promotions",
  SecurityManagement = "SecurityManagement",
  StoreSuppliers = "StoreSuppliers",
  StoreZones = "StoreZones",
  StoreDeptXrefs = "StoreDeptXrefs",
  TagHandlingInstructions = "TagHandlingInstructions",
  TagReplacementStoreRequest = "TagReplacementStoreRequest",
  TagFullScanShelfTagRequest = "TagFullScanShelfTagRequest",
  DisplayPriceDetails = "DisplayPriceDetails",
  FamilyMaint = "FamilyMaint",
  ScaleDepartments = "ScaleDepartments",
  ScaleTareCodes = "ScaleTareCodes",
  CaseInterpackItem = "CaseInterpackItem",
  PosFileCompare = "PosFileCompare",
  Journal = "Journal",
  UpcRecalls = "UpcRecalls",
  AdGroups = "AdGroups",
  AdBlocks = "AdBlocks",
  Scanbacks = "Scanbacks",
  SecondaryPromotions = "SecondaryPromotions",
  SpecialtyPromotions = "SpecialtyPromotions",
  EOffers = "EOffers",
  ShipperMaint = "ShipperMaint",
  DisplayShippers = "DisplayShippers",
  ShipperRetail = "ShipperRetail",
  MaintainPromotionPrices = "MaintainPromotionPrices",
  AddFuturePromotions = "AddFuturePromotions",
  PromoPricingByBanner = "PromoPricingByBanner",
  RegularPricing = "RegularPricing",
  PromoPricing = "PromoPricing",
  AddPendingPricing = "AddPendingPricing",
  Feedback = "Feedback",
  PromotionBenchmarkCodes = "PromotionBenchmarkCodes",
  PromotionTypesRules = "PromotionTypesRules",
  PromotionItemTypes = "PromotionItemTypes",
  PromotionGroups = "PromotionGroups",
  RewardPromotionStatus = "RewardPromotionStatus",
  AdDisplayPlan = "AdDisplayPlan",
  ScanbackEntryTypes = "ScanbackEntryTypes",
  AdType = "AdType",
  SecondaryPromoLinks = "SecondaryPromoLinks",
  ScanbackBusinessUnits = "ScanbackBusinessUnits",
  AdvertisedItemCodes = "AdvertisedItemCodes",
  PromotionActionCodes = "PromotionActionCodes",
  AdPriceFormat = "AdPriceFormat",
  DistributionMethod = "DistributionMethod",
  AdLocation = "AdLocation",
  // Item Pricing validation lists
  RuleOperationCodes = "RuleOperationCodes",
  AccountPromotionXref = "AccountPromotionXref",
  RuleBaseCode = "RuleBaseCode",
  PriceBookCodes = "PriceBookCodes",
  PriceBasis = "PriceBasis",
  EdlpDeleteDate = "EdlpDeleteDate",
  PriceReasonCodes = "PriceReasonCodes",
  PriceStatusCodes = "PriceStatusCodes",
  CompetitorBanners = "CompetitorBanners",
  RuleTargetCodes = "RuleTargetCodes",
}

// Define the feature flags with their statuses for different environments
// This is a utility to manage feature flags based on the environment
// and to check if a feature is enabled or not.
const features = [
  {
    name: featureFlags.Stores,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.ZoneBanners,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.CopyStoreDSD,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.StoreSuppliers,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.StoreZones,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.Suppliers,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.ReceivingRestrictions,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.UserClaims,
    development: true,
    staging: true,
    // Enabled 2026-07-07: without the claims call every prod user had
    // RP_USER_TYPE "" and supplier create fell into the wholesale flow.
    // Prod gateway routes /api/utility/User/Claims (verified 401-not-404)
    // and the production BE branch has UserController + middleware.
    production: true,
  },
  {
    name: featureFlags.ItemStateFlag,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.MaintainStoreCoupons,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.MiscellaneousTransactionCodes,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.Admin,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.ShipperCost,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.CopyStoreZones,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.StoreDeptXrefs,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.DealCost,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.DSDCostLink,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.DisplayCostDetails,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.ItemMaintenance,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.Promotions,
    development: true,
    staging: false,
    production: false,
  },
  {
    // QA Access — RP_USER_ROLES self-service. On in dev and QA, where testers
    // need it; OFF in production, where a screen that grants its own roles has
    // no business existing. This is the SECOND of two independent switches:
    // the API refuses the writes as well unless SelfServiceRoles:Enabled is
    // set, which production never sets. Turning this flag on by itself would
    // give production a read-only role browser, not a role editor.
    name: featureFlags.SecurityManagement,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.TagHandlingInstructions,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.TagReplacementStoreRequest,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.TagFullScanShelfTagRequest,
    development: true,
    staging: true,
    production: true,
  },
  {
    // On for QA (2026-09-29) with the zone / store "Look at".
    name: featureFlags.DisplayPriceDetails,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.FamilyMaint,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.ScaleDepartments,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.ScaleTareCodes,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.CaseInterpackItem,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.PosFileCompare,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.Journal,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.UpcRecalls,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.AdGroups,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.AdBlocks,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.Scanbacks,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.SecondaryPromotions,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.SpecialtyPromotions,
    development: true,
    staging: false,
    production: false,
  },
  {
    // eOffers (digital coupons) - port of the stand-alone
    // GE.Web.DigitalCouponExclusion app (MERCHIT-151). Reads for everyone,
    // exclusion writes gated on EOFFER_EXCLUSION grants.
    name: featureFlags.EOffers,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.PseudoUpc,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.PriceGroupMove,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.ShipperMaint,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.DisplayShippers,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.ShipperRetail,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.MaintainPromotionPrices,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.AddFuturePromotions,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.PromoPricingByBanner,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.RegularPricing,
    development: true,
    staging: true,
    production: true,
  },
  {
    name: featureFlags.PromoPricing,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.AddPendingPricing,
    development: true,
    staging: false,
    production: false,
  },
  {
    name: featureFlags.Feedback,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.PromotionTypesRules,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.PromotionBenchmarkCodes,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.PromotionItemTypes,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.PromotionGroups,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.RewardPromotionStatus,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.AdDisplayPlan,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.ScanbackEntryTypes,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.AdType,
    development: true,
    staging: true,
    production: false,
  },
  {
    name: featureFlags.SecondaryPromoLinks,
    development: true,
    staging: true,
    production: false,
  },
  {
     name: featureFlags.ScanbackBusinessUnits,
     development: true,
     staging: true,
     production: false,
  },
  { name: featureFlags.AdvertisedItemCodes, development: true, staging: true, production: false },
  { name: featureFlags.PromotionActionCodes, development: true, staging: true, production: false },
  { name: featureFlags.AdPriceFormat, development: true, staging: true, production: false },
  { name: featureFlags.DistributionMethod, development: true, staging: true, production: false },
  { name: featureFlags.AdLocation, development: true, staging: true, production: false },
  // Item Pricing validation lists — on in dev + QA, off in production until signed off.
  { name: featureFlags.RuleOperationCodes, development: true, staging: true, production: false },
  { name: featureFlags.AccountPromotionXref, development: true, staging: true, production: false },
  { name: featureFlags.RuleBaseCode, development: true, staging: true, production: false },
  { name: featureFlags.PriceBookCodes, development: true, staging: true, production: false },
  { name: featureFlags.PriceBasis, development: true, staging: true, production: false },
  { name: featureFlags.EdlpDeleteDate, development: true, staging: true, production: false },
  { name: featureFlags.PriceReasonCodes, development: true, staging: true, production: false },
  { name: featureFlags.PriceStatusCodes, development: true, staging: true, production: false },
  { name: featureFlags.CompetitorBanners, development: true, staging: true, production: false },
  { name: featureFlags.RuleTargetCodes, development: true, staging: true, production: false },
];

// Function to check if a feature is enabled based on the environment
export const isFeatureEnabled = (featureName: featureFlags): boolean => {
  try {
    const env = import.meta.env.VITE_NODE_ENV;
    const feature = features.find((f) => f.name === featureName);

    if (!feature) {
      console.warn(`Feature flag "${featureName}" not found.`);
      return false; // Default to false if feature not found
    }

    switch (env) {
      case "development":
        return feature.development;
      case "staging": // UAT
        return feature.staging;
      case "production":
        return feature.production;
      default:
        console.warn(
          `Unknown environment: ${env}. Defaulting to false for feature "${featureName}".`
        );
        return false;
    }
  } catch (error) {
    console.error("Error checking feature flag:", error);
    return false; // Default to false in case of any error
  }
};
